export const apiStatusCodes = {
    SUCCESS: 'SPG-0000',
    SUCCESS2: 'SPGM-0000',
    SUCCESS3: 'SPGPL-2000',
    SUCCESS4: 'SPG-2000',
    NORECORD: 'ER-S053',
};
